import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const TextContainer = styled.div`
  font-family: ${fonts.body};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};

  > div + div {
    margin-top: ${space['space-400']};
  }

  &[data-clamped='true'] {
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-orient: vertical;
    overflow: hidden;
    /* line-clamp is applied via inline CSS variable */
    -webkit-line-clamp: var(--max-lines, 4);
  }
`;

export const ToggleButton = styled.button`
  display: inline;
  align-self: flex-start;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  text-decoration: underline;
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
    border-radius: ${space['space-050']};
  }

  &:hover {
    opacity: 0.85;
  }
`;
